import { DateTime } from 'luxon';

export const profileDrv = {
    namespaced: true,

    state: {
        date: {
            startDate: null,
            endDate: null
        },
        tab: 'training'
    },

    getters: {
        getStartDate(state) {
            return DateTime.fromISO(state.date.startDate).toISODate();
        },

        getEndDate(state) {
            return DateTime.fromISO(state.date.endDate).toISODate();
        },

        getTab(state) {
            return state.tab;
        }
    },

    mutations: {
        setStartDate(state, date) {
            state.date.startDate = date;
        },

        setEndDate(state, date) {
            state.date.endDate = date;
        },

        setTab(state, payload) {
            state.tab = payload;
        }
    }
};

export default profileDrv;
